import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NetworkRenderer } from 'components/NetworkRenderer/NetworkRenderer';
import { AmountRenderer } from 'components/AmountRenderer/AmountRenderer';
import { Token } from 'pages/TransferPage/TransferPage.types';
import { GET_PEGIN_LOGS_API, SOURCE_CHAINS, } from 'pages/TransferPage/TransferPage.constants';
export const generateRowTitle = (row) => (_jsxs("div", { className: "text-left text-[0.813rem] text-sov-white font-medium flex items-center justify-between w-full", children: [_jsx(NetworkRenderer, { network: SOURCE_CHAINS[0], iconSize: 20 }), _jsx("div", { className: "flex items-center", children: _jsx(AmountRenderer, { value: row.amount, suffix: Token.BTC, decimals: 10, precision: 8 }) })] }));
export const getHistory = async (filter) => {
    const params = new URLSearchParams(filter);
    const res = await fetch(`${GET_PEGIN_LOGS_API}?${params}`, {
        method: 'GET',
    });
    const data = (await res.json());
    return data.data || [];
};
